import React, { useEffect, useState } from "react";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import api from "../api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

const Cobros = () => {
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [dbUser, setDbUser] = useState("");
  const [cobros, setCobros] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedCobro, setSelectedCobro] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setFirebaseUser(user || null);
      setDbUser(user ? user.displayName || user.uid : "");
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!dbUser) return;
    const nowEpoch = Math.floor(Date.now() / 1000);

    api.cobrosFecha(dbUser, 0, nowEpoch).then(setCobros);

  }, [dbUser]);

  const handleEdit = (cobro) => {
    setSelectedCobro({ ...cobro });
    setOpenEditModal(true);
  };

  const handleEditChange = (e) => {
    setSelectedCobro({
      ...selectedCobro,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveEdit = async () => {
    if (!selectedCobro) return;
    await api.updateCobro(selectedCobro);
    setCobros(cobros.map((c) => (c.id === selectedCobro.id ? selectedCobro : c)));
    setOpenEditModal(false);
  };

  const columns = [
    { Header: "Fecha", accessor: "fecha", Cell: ({ value }) => (<b>{new Date(value * 1000).toISOString().slice(0, 10)}</b>) },
    { Header: "Monto USD", accessor: "monto_usd" },
    { Header: "PIN", accessor: "pin" },
    {
      Header: "Acciones",
      accessor: "acciones",
      Cell: ({ row }) => (
        <IconButton color="primary" onClick={() => handleEdit(row.original)}>
          <Edit />
        </IconButton>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom color="primary">
            Cobros
          </Typography>
          <DataTable table={{ columns, rows: cobros }} isSorted entriesPerPage showTotalEntries canSearch />
        </CardContent>
      </Card>

      {/* MODAL DE EDICIÓN */}
      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)}
        sx={{ "& .MuiPaper-root": { bgcolor: "background.default", color: "white" } }}>
        <DialogTitle>Editar Cobro</DialogTitle>
        <DialogContent>
          {selectedCobro && (
            <MDBox p = {2}>
              <MDInput label="Monto USD" name="monto_usd" type="number" value={selectedCobro.monto_usd} onChange={handleEditChange} fullWidth />
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditModal(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
};

export default Cobros;
